// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NormalImage_wrapper__VdP8r","grayscale":"NormalImage_grayscale__f_iVh"};